import { STORE_LOCALE_AGREEMENT, STORE_LOCATION_MODAL_IS_OPEN } from "actions"

export const initialState = {
  locationAgree: "0",
  locationModalIsOpen: false,
}

export const LocaleAgreement = (state = initialState, action) => {
  switch (action.type) {
    case STORE_LOCALE_AGREEMENT:
      return { ...state, ...action.payload }
    case STORE_LOCATION_MODAL_IS_OPEN:
      return { ...state, locationModalIsOpen: action.payload }
    default:
      return state
  }
}

export default LocaleAgreement
